import {get} from '../utils'

export default host => (id) =>
  get(`${host}/albums/${id}/downloadZip`)

